import { AcpLogo, BackSvg } from '../../../../CommonComponents/svgs/Svgs'
import useModal from '../../hooks/useModal'
import useThermalHeatmap from '../../hooks/useThermalHeatmap'
import './ScenarioHeader.scss'

const ScenarioHeader = () => {
    const { onCloseScenario } = useModal()
    const { isThermalFullscreen } = useThermalHeatmap()

    if (isThermalFullscreen) return null

    return (
        <div className='scenario__header'>
            <button className='logo__container'
                onClick={() => onCloseScenario('Home')}
            >
                <AcpLogo />
            </button>
            <button className='home__button__container'
                onClick={() => onCloseScenario('Dashboard')}
            >
                <BackSvg />
            </button>
        </div>
    )
}

export default ScenarioHeader